import styled from 'styled-components';
import { space } from 'styled-system';
import themeGet from '@styled-system/theme-get';

import { fixPropWarnings } from '../../utils/fixPropWarnings';

interface StepButtonProps {
  isActive: boolean;
  tabIndex?: number | string;
  disabled?: boolean;
  'aria-label'?: string;
}

export const ProductStepCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 500px;
  width: 100%;
  padding: 40px 30px;
  margin: 0 auto;
  background-color: ${themeGet('colors.white')};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    max-width: 400px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StepControls = styled.div`
  display: flex;
  align-items: center;
  margin: 0;

  ${space}
`;

export const Panel = styled.div``;

export const StepButton = styled.button.withConfig(fixPropWarnings('isActive'))<StepButtonProps>`
  flex: 0 0 auto;
  margin: 0 10px 0 0;
  position: relative;
  transition: opacity 300ms ease;

  color: ${themeGet('colors.white')};
  background-color: ${themeGet('colors.red')};
  opacity: ${({ isActive }) => (isActive ? '1' : '0.2')};
  width: 40px;
  height: 40px;
  border-radius: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;

  :hover,
  :focus {
    background-color: ${themeGet('colors.red')};
  }
`;

export const TitleWrapper = styled.div`
  display: block;
  margin: 2rem 0;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    * {
      display: inline;
    }
  }
`;

export const StepTitle = styled.p`
  font-size: 22px;
  font-weight: ${themeGet('fontWeights.bold')};
  margin: 0;

  span {
    margin-right: 0.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    span {
      margin-right: 1rem;
    }
  }
`;

export const Body = styled.div`
  ul {
    list-style: outside disc;

    li {
      margin: 0 0 0 1rem;
    }
  }
`;

export const Pagination = styled.div`
  width: 100%;
  display: flex;
  align-content: center;
  justify-content: center;
`;

export const PageControl = styled.button`
  flex: 0 0 auto;
  margin: 0 15px;
  position: relative;
  transition: opacity 300ms ease;
  opacity: ${({ disabled }) => (!disabled ? '1' : '0.2')};
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
